import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=4c803979&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=ts&"
export * from "./Index.vue?vue&type=script&lang=ts&"
import style1 from "./Index.vue?vue&type=style&index=1&id=4c803979&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c803979",
  null
  
)

export default component.exports